import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import Images from "assets/images"
import { EDIT, PAYMENT_CURRENCY } from "const"
import { hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_CC_LIBRARY,
    StoreType,
    IsOwnerCcLibrarySet,
    addModal,
    LangType,
} from "client/store"
import {
    PageForm,
    Logo,
    FormGroup,
    Label,
    Input,
    DivInput,
    Textarea,
    UserIcon,
    Button,
} from "client/components"

const Form = () => {
    const set = useSelector((state: StoreType) => state.ccLibrarySet.setView)
    const baseRoute = useSelector((state: StoreType) => state.ccLibrarySet.baseRoute)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const accountList = useSelector((state: StoreType) => state.account.accountList)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editUrl = `${baseRoute}/${EDIT}/${set.id}`

    const editAccess = !project.id
        ? hasAccess(PRM_CC_LIBRARY, EDIT)
        : hasProjectAccess(PRM_CC_LIBRARY, EDIT)

    const isOwner = IsOwnerCcLibrarySet(project.id, set, userData)
    const allowedToEdit = editAccess || isOwner

    const creator = set.creator && userList[set.creator]
    const ownerAccount = set.ownerAccount && accountList[set.ownerAccount]
    return (
        <PageForm>
            <Row>
                <Col xs={12} md={3}>
                    <Logo logo={set.logo || Images.complianceSetLogo} />
                </Col>
                <Col xs={12} md={9}>
                    <Row>
                        <Col xs={12} md={4}>
                            <FormGroup>
                                <Label>{lang.publicId}</Label>
                                <Input type="text" value={set.publicId} readOnly />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={8}>
                            <FormGroup>
                                <Label>{lang.name}</Label>
                                <Input type="text" value={set.name} readOnly />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{lang.description}</Label>
                                <Textarea value={set.description} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.owner}</Label>
                                {
                                    !project.id && set.ownerAccount === userData.accountId && (
                                        <DivInput><UserIcon user={creator} size="sm" /></DivInput>
                                    )
                                }
                                {
                                    !project.id && set.ownerAccount !== userData.accountId && (
                                        <Input type="text" value={ownerAccount ? ownerAccount.name : ""} readOnly />
                                    )
                                }
                                {
                                    project.id && (
                                        <Input type="text" value={ownerAccount ? ownerAccount.name : ""} readOnly />
                                    )
                                }
                            </FormGroup>
                        </Col>
                        <Col xs={!project.id ? 6 : 12}>
                            <FormGroup>
                                <Label>{lang.default}</Label>
                                <Input type="text" value={set.default ? lang.yes : lang.no} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.formal}</Label>
                                <Input type="text" value={set.formal ? lang.yes : lang.no} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.locked}</Label>
                                <Input type="text" value={set.locked ? lang.yes : lang.no} readOnly />
                            </FormGroup>
                        </Col>
                        {
                            !project.id && (
                                <Col xs={6}>
                                    <FormGroup>
                                        <Label>{lang.access}</Label>
                                        <Input type="text" value={lang[set.access as keyof LangType]} readOnly />
                                    </FormGroup>
                                    {
                                        set.accountId === 1 && (
                                            <FormGroup>
                                                <Label>{`${lang.cost}, ${PAYMENT_CURRENCY}`}</Label>
                                                <Input type="text" value={set.cost === 0 ? lang.free : set.cost.toFixed(2)} readOnly />
                                            </FormGroup>
                                        )
                                    }
                                    <FormGroup>
                                        <Label>{lang.status}</Label>
                                        <Input type="text" value={lang[set.status as keyof LangType]} readOnly />
                                    </FormGroup>
                                </Col>
                            )
                        }
                        {
                            allowedToEdit && (
                                <Col xs={12}>
                                    <Button onClick={() => dispatch(addModal({ url: editUrl }))}>
                                        {lang.edit}
                                    </Button>
                                </Col>
                            )
                        }
                    </Row>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
